<template>
  <div>
    <div id="banner">
      <div class="slider-pro" id="example1">
        <div class="sp-slides">
          <div class="sp-slide"><a href="javascript:void(1)" style='cursor:default'><img class="sp-image"
                src="~@/assets/15132207041.jpg" alt="" title=""></a>
          </div>
          <div class="sp-slide"><a href="javascript:void(1)" style='cursor:default'><img class="sp-image"
                src="~@/assets/15108175421.jpg" alt="" title=""></a>
          </div>
          <!--
          <div class="sp-slide"><a href="javascript:void(1)" style='cursor:default'><img class="sp-image"
                src="~@/assets/14994016861.jpg" alt="" title=""></a>
          </div>
          -->
        </div>
      </div>
    </div>

    <div id="wrap_c">
      <div>
        <!--###內頁中間內容區塊###-->
        <div id="left_column">
          <div class="left_column_c id2346">
            <div class="ad_c2">
              <h2 style="padding: 100px 50px; text-align: center;"><span
                  style="color: rgb(128, 128, 128);"><strong><span
                      style="font-size: 180%;">以材料為核心之科技公司</span></strong><br />
                  <strong>無機材料｜有機材料｜光學薄膜｜生醫新藥</strong><br />
                  <br />
                  <br />
                  <strong>[ 關鍵核心技術 ]</strong><br />
                  <strong>材料研發與製造</strong><br />
                  <b>高階光電薄膜設計與製程</b><br />
                  <b>精密製造</b></span></h2>
            </div>
          </div>
          <div class="left_column_c id2348">
            <div class="ad_c2">
              <div class="s631_index_02">
                <div class="s631_index_02_w">
                  <div class="s631_index_02_wc">
                    <h2>產品項目</h2>
                    <span style="font-size: 20px;">色彩補正玻璃(藍玻璃) IR absorbing filter<br />
                      <br />
                      光學低通濾波片 Optical Low Pass Filter<br />
                      <br />
                      視覺模擬濾光片 Vision lambda filter (X,Y,Z filter)<br />
                      <br />
                      紅外光窄帶濾片 3D Sensing filter<br />
                      <br />
                      玻璃粉 Glass powder</span>
                  </div>
                </div>
                <div class="s631_index_02_img">&nbsp;</div>
              </div>
            </div>
          </div>
          <div class="left_column_c id2349">
            <div class="ad_c2">
              <div class="s631_index_03">
                <div class="s631_index_03_img"></div>
                <div class="s631_index_03_w">
                  <div class="s631_index_03_wc">
                    <h2>導邊(Bevel cutting)</h2>

                    <p>本公司藍玻璃具有極佳的韌性,為進一步確保客戶對崩邊的需求,本公司可提供玻璃導邊的產品。</p>

                    <h2>印框(Black Masking)</h2>

                    <p>針對堆棧式(Stack sensor)的特性,本公司可提供加印黑框的製程。</p>

                    <h2>重組(Re-con)</h2>

                    <p>為提高客戶組裝效率,提供良品包裝的製程。</p>

                    <h2>自動光學檢測(AOI)</h2>

                    <p>進一步確保出貨檢驗水準。</p>

                    <h2>支援客戶組裝技術</h2>

                    <p>材料自製,後段加工製程亦為內製,客戶廣泛,擁有豐富之CCM前段製程經驗,提供客戶有效之Particle改善技術支援。</p>
                  </div>
                </div>

                <div class="s631_index_04">
                  <div class="s631_index_01">
                    <h1 class="s631_index_01_w" style="text-align: center;"><br />
                      <span style="color: rgb(169, 169, 169);"><span style="font-size: 120%;">追求客戶滿意的品質 , 價值 ,
                          交期及支援服務為白金科技的唯一標準</span></span></h1>
                  </div>

                  <p>&nbsp;</p>
                </div>
              </div>
            </div>
          </div>
          <div class="left_column_c id2350">
            <div class="ad_c2">
              <div class="s631_index_05">
                <div class="s631_index_05_img">
                  <router-link :to="{name:'公司簡介'}" >
                    <img alt=""
                      class="s631_index_ggg"
                      src="@/assets/15040789601.jpg" />
                  </router-link>
                  <div class="overlay">
                    <div class="text">
                      <p>關於白金</p>
                      <h3>About Us</h3>
                      <p>
                        <router-link :to="{name:'公司簡介'}" >more</router-link>
                      </p>
                    </div>
                  </div>
                </div>

                <div class="s631_index_05_img">
                  <router-link :to="{name:'產品與服務'}" >
                    <img alt=""
                      class="s631_index_ggg"
                      src="@/assets/15041765451.jpg" />
                  </router-link>
                  <div class="overlay">
                    <div class="text">
                      <p>產品與服務</p>
                      <h3>Products &amp; Service</h3>
                      <p>
                        <router-link :to="{name:'產品與服務'}" >more</router-link>
                      </p>
                    </div>
                  </div>
                </div>

                <div class="s631_index_05_img">
                  <router-link :to="{name:'加入白金'}" >
                    <img alt=""
                      class="s631_index_ggg"
                      src="@/assets/15051826621.jpg" />
                  </router-link>
                  <div class="overlay">
                    <div class="text">
                      <p>人才招募</p>
                      <h3>Job Opportunities</h3>
                      <p>
                        <router-link :to="{name:'加入白金'}" >more</router-link>
                      </p>
                    </div>
                  </div>
                </div>

                <div class="s631_index_05_img">
                  <router-link :to="{name:'營業據點'}" >
                    <img alt=""
                      class="s631_index_ggg"
                      src="@/assets/15040823001.jpg" />
                  </router-link>
                  <div class="overlay">
                    <div class="text">
                      <p>聯絡我們</p>
                      <h3>Contact Us</h3>
                      <p>
                        <router-link :to="{name:'營業據點'}" >more</router-link>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Home',
  metaInfo() {
    return {
      title: `白金科技股份有限公司`,
      meta: [
        { name: 'author', content: '白金科技股份有限公司' },
        { name: 'description', content: '光學玻璃材料專業製造廠 光學玻璃材質都以特殊成分的配方、熔融時間、冷卻方式與時間等等的差異來改變（或決定）其光學性能。光學玻璃的透明度及其內部的均一性必須要十分良好；又由於「像差 補正」的需要，有關它對光的折射及色散之特性，必需精確掌握。因此，光學玻璃所使用原材料，不僅經過精密的選別，並且需要以現代科學化的 管理與技術來製造。 本公司經營團隊擁有完整的基礎光學材料研發及製程開發技術，並有10年以上量產實務經驗，經多年埋首研究，已成功開發出應用於光電產業的各類光電介面材料。本公司專注於研究、開發及生產光電介面材料，目前主要產品為搭配影像感測器之吸收式紅外線濾光鏡片，係應用於數位影像之關鍵元件，其他產品亦將陸續推出。'},
        { name: 'keywords', content: '白金,科技,PTOT,光學,玻璃,材料,專業製造廠,Platinum,Optics,Technology,inc'},
        { property: 'og:title', content: '白金科技股份有限公司'},
        { property: 'og:site_name', content: '白金科技股份有限公司'},
        { property: 'og:description', content: '光學玻璃材料專業製造廠 光學玻璃材質都以特殊成分的配方、熔融時間、冷卻方式與時間等等的差異來改變（或決定）其光學性能。光學玻璃的透明度及其內部的均一性必須要十分良好；又由於「像差 補正」的需要，有關它對光的折射及色散之特性，必需精確掌握。因此，光學玻璃所使用原材料，不僅經過精密的選別，並且需要以現代科學化的 管理與技術來製造。 本公司經營團隊擁有完整的基礎光學材料研發及製程開發技術，並有10年以上量產實務經驗，經多年埋首研究，已成功開發出應用於光電產業的各類光電介面材料。本公司專注於研究、開發及生產光電介面材料，目前主要產品為搭配影像感測器之吸收式紅外線濾光鏡片，係應用於數位影像之關鍵元件，其他產品亦將陸續推出。'},
        {property: 'og:type', content: 'website'},
        {property: 'og:url', content: 'http://www.ptotinc.com' },
        {property: 'og:image', content: '/users/'  }    
      ]
    }
  },
  data: {
    
  },
  created: function () {
    console.log('created')
  },
  mounted: function () {
    console.log('moundted')
    this.init()
    this.$emit('setCurrentMenu', null); // about/ product/ recruit/ contactus
    // sliderPro.m1()
    // sliderProAddTitle('default', '%%%%%%%%%@@@%%%%%%%%%@@@', '%%%%%%%%%@@@%%%%%%%%%@@@')
    // sliderPro.initialSliderPro()
    // sliderPro.m1('default', '%%%%%%%%%@@@%%%%%%%%%@@@', '%%%%%%%%%@@@%%%%%%%%%@@@')
  },
  methods: {
    init: function () {
      $('#example1').sliderPro({
        keyboardOnlyOnFocus: true,
        width: '5120',
        height: '2048',
        autoplay: true,
        waitForLayers: true,
        autoScaleLayers: false,
        fade: true,
        autoplayDelay: 5000,
        arrows: false,
        buttons: false,
        breakpoints: {
          1024: {
            forceSize: '',
            width: '1024',
            height: '410',
          }
        }
      });
      sliderPro_add_title('default', "%%%%%%%%%@@@%%%%%%%%%@@@%%%%%%%%%@@@使數位影像呈現地球自然的顏色%%%#fff%%%%%%置中@@@", "%%%%%%%%%@@@%%%%%%%%%@@@%%%%%%%%%@@@%%%%%%%%%@@@");
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style src='@/assets/css/home.css'>

</style>
<style scoped>
#wrap_c {
  max-width: 100vw;
}
</style>


// WEBPACK FOOTER //
// src/components/Home.vue